import { Skeleton } from '@/components/ui/skeleton'

export const AutoDeployFallback = () => <Skeleton className="h-18 w-full" />
